import React, { useState, useEffect, useCallback } from 'react'

import { useQueryParams } from 'raviger'
import { toastWithErrorMessage } from 'Helpers/toast'

import Separator from 'Components/shared/Separator'
import VirtualOfficesService from 'Services/virtual-offices'
import UpdateVirtualOfficeForm from './Forms/Update'

import { UserTableVirtualOffice } from '../Users/Table'
import AddUser from './Forms/Add-User'

import InvitesTable from '../Invites/Table'
import CreateInvite from '../Invites/Create'

export default () => {
  const [{ id }] = useQueryParams()
  const [virtualOffice, setVirtualOffice] = useState()
  const setInvites = useCallback(invites => setVirtualOffice({ ...virtualOffice, invites }), [
    virtualOffice
  ])

  useEffect(async () => {
    setVirtualOffice(
      await VirtualOfficesService.get({ virtualOfficeId: id }).catch(
        toastWithErrorMessage('Failed to get virtual office info')
      )
    )
  }, [])

  const updateVirtualOffice = async () => {
    setVirtualOffice(
      await VirtualOfficesService.get({ virtualOfficeId: id }).catch(
        toastWithErrorMessage('Failed to get virtual office info')
      )
    )
  }

  return (
    <>
      {virtualOffice && (
        <>
          <UpdateVirtualOfficeForm
            virtualOffice={virtualOffice}
            setVirtualOffice={setVirtualOffice}
          />
          <Separator />
          <AddUser virtualOffice={virtualOffice} setVirtualOffice={setVirtualOffice} />
          <UserTableVirtualOffice
            virtualOffice={virtualOffice}
            setVirtualOffice={setVirtualOffice}
          />
          <Separator />
          <CreateInvite virtualOfficeId={virtualOffice.id} onUpdate={updateVirtualOffice} />
          <InvitesTable invites={virtualOffice.invites} setInvites={setInvites} canArchive />
        </>
      )}
    </>
  )
}
